var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block"},[_c('el-timeline',[_c('el-timeline-item',{attrs:{"timestamp":"2025/1/9","placement":"top"}},[_c('el-card',[_c('h1',[_vm._v("更新仓储平台 任务下发")]),_c('p',[_vm._v("表格内数据可双击复制")]),_c('img',{attrs:{"src":require("../assets/images/log/dbclick.png"),"alt":""}})])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }